import type { LegalDocument } from "./types";

/**
 * Shared presenter for Privacy + Terms. Keeps typography and section
 * rhythm in one place so the two documents always look identical —
 * useful because users routinely bounce between them and any visual
 * difference reads as "these were written by different people at
 * different times", which is the opposite of what we want.
 */
export function LegalDocumentView({ doc }: { doc: LegalDocument }) {
  return (
    <article className="text-sm leading-relaxed text-ink/80 dark:text-paper/80">
      <p className="font-mono text-[11px] uppercase tracking-wider text-ink/50 dark:text-paper/50">
        {doc.lastUpdated}
      </p>

      <div className="mt-4 space-y-4">
        {doc.preamble.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </div>

      <div className="mt-8 space-y-7">
        {doc.sections.map((s) => (
          <section key={s.heading}>
            <h3 className="font-display text-base font-semibold text-ink dark:text-paper">
              {s.heading}
            </h3>
            <div className="mt-2 space-y-3">
              {s.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </section>
        ))}
      </div>

      <p className="mt-10 pt-6 border-t border-margin dark:border-paper/10 text-xs text-ink/60 dark:text-paper/60">
        {doc.contact}
      </p>
    </article>
  );
}
